import { GoToAccountSettingsCTA } from "./ctas";
export var AccountEmailIA = function AccountEmailIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return CHANGE_LOGIN_EMAIL(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_CHANGE_YOUR_LOGIN_EMAIL(strictLocalize), IN_MY_ACCOUNT_TAB(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var CHANGE_LOGIN_EMAIL = function CHANGE_LOGIN_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "S9vowT",
    defaultMessage: [{
      "type": 0,
      "value": "E-mailadres voor inloggen wijzigen"
    }]
  });
};
var YOU_CAN_CHANGE_YOUR_LOGIN_EMAIL = function YOU_CAN_CHANGE_YOUR_LOGIN_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "nDo/2C",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt je e-mailadres voor inloggen wijzigen door op de knop met het gebruikerspictogram in de rechterbovenhoek van het retailerportaal te klikken en de optie ‘Account’ te selecteren."
    }]
  });
};
var IN_MY_ACCOUNT_TAB = function IN_MY_ACCOUNT_TAB(strictLocalize) {
  return strictLocalize({
    id: "aVc5Su",
    defaultMessage: [{
      "type": 0,
      "value": "Zoek op het tabblad ‘Mijn profiel’ het gedeelte ‘Persoonlijke informatie’ en typ het nieuwe e-mailadres voor het inloggen in het vakje ‘E-mailadres van account’. Klik ten slotte op de knop ‘Opslaan’ om de wijzigingen op deze pagina op te slaan."
    }]
  });
};